export async function apiFetch(input: RequestInfo, init?: RequestInit): Promise<Response> {
  const res = await fetch(input, { credentials: 'include', ...init })
  if (res.status === 401) {
    localStorage.removeItem('user')
    window.location.replace('/login')
  }
  return res
}
